const SearchType = {
  ALERT: 0,
  DEVICE: 1,
  CHANNEL: 2,
};

export default SearchType;
